import { getAuthData } from "../auth/session.js";

const pendingKey = "metacard-tbank-order";

export async function paymentRequest(path, data) {
  const response = await fetch(`/api/payments/${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ ...data, initData: getAuthData() }),
    signal: AbortSignal.timeout(15000),
  });
  const result = await response.json();
  if (!response.ok) throw new Error(result.error || "Не удалось проверить оплату");
  return result;
}

export async function openTbankPayment(coins, custom, email) {
  if (!getAuthData()) throw new Error("Войдите в аккаунт для оплаты");
  // Open synchronously to preserve the browser's user-gesture popup permission.
  const telegram = window.Telegram?.WebApp;
  const popup = telegram?.openLink ? null : window.open("about:blank", "_blank");
  if (popup) popup.opener = null;
  try {
    const result = await paymentRequest("metacoin-tbank", { coins, custom, email });
    localStorage.setItem(pendingKey, result.paymentId);
    if (telegram?.openLink) telegram.openLink(result.paymentUrl);
    else if (popup) popup.location.replace(result.paymentUrl);
    else window.location.assign(result.paymentUrl);
    window.dispatchEvent(new Event("metacard-payment-pending"));
  } catch (error) {
    popup?.close();
    throw error;
  }
}

export function watchTbankPayment(onPaid, onNotice) {
  let stopped = false;
  let busy = false;
  const query = new URL(window.location.href);
  const returnedOrder = query.searchParams.get("tbank_order");
  if (/^[a-f0-9]{32}$/.test(returnedOrder || "")) {
    localStorage.setItem(pendingKey, returnedOrder);
    query.searchParams.delete("tbank_order");
    window.history.replaceState(window.history.state, "", query);
  }
  const check = async () => {
    const paymentId = localStorage.getItem(pendingKey);
    if (stopped || busy || document.hidden || !paymentId || !getAuthData()) return;
    busy = true;
    try {
      const result = await paymentRequest("tbank/status", { paymentId });
      if (stopped || localStorage.getItem(pendingKey) !== paymentId) return;
      if (result.paid || result.failed) {
        localStorage.removeItem(pendingKey);
        if (result.paid) onPaid(result);
        else onNotice("Оплата отменена или отклонена банком");
      }
    } catch {
      // Retain the order for the next foreground check; a timeout is not a failure.
    } finally {
      busy = false;
    }
  };
  const timer = window.setInterval(check, 5000);
  window.addEventListener("focus", check);
  window.addEventListener("metacard-payment-pending", check);
  document.addEventListener("visibilitychange", check);
  check();
  return () => {
    stopped = true;
    window.clearInterval(timer);
    window.removeEventListener("focus", check);
    window.removeEventListener("metacard-payment-pending", check);
    document.removeEventListener("visibilitychange", check);
  };
}
